import React, {useState} from 'react';
import {IconEllipsisHorizontal} from "../../../../components/icons";

const Kpi = (
  {
    value = '',
    label = '',
    color = '',
    description = ''
  }: {
    value?: string,
    label?: string,
    color?: string,
    description?: string
  }
) => {
  const [displayPerformanceExplanation, setDisplayPerformanceExplanation] = useState<boolean>(false);

  return (
    <div
      className="relative"
      onMouseOver={() => setDisplayPerformanceExplanation(true)}
      onMouseOut={() => setDisplayPerformanceExplanation(false)}
    >
      <div className="bg-white pt-4 rounded-xl shadow flex justify-center items-center hover:shadow-md">
        <div className="text-center gap-2">
          <p className={`text-2xl font-bold ${color}`}>{value}</p>
          <p className="text-gray-500 min-h-[40px] text-sm font-semibold">{label}</p>
          <div className="flex items-center justify-center">
            <IconEllipsisHorizontal className="w-10 h-10 text-gray-400"/>
          </div>
        </div>
      </div>
      {(displayPerformanceExplanation && description !== '') && (
        <div className="absolute mt-1 bg-white p-3 rounded-xl border border-white/1 min-w-[225px] shadow-lg z-20">
          <p className="text-xs text-gray-500">
            {description}
          </p>
        </div>
      )}
    </div>
  );
};

export default Kpi;